import { Grid } from '@mui/material';
import React from 'react';
import Color from './shared/Color';
import { UpdateFn } from './types';

type Props = {
	primary: string;
	updatePrimary: UpdateFn;
	secondary: string;
	updateSecondary: UpdateFn;
	link: string;
	updateLink: UpdateFn;
	error: string;
	updateError: UpdateFn;
};

const Inputs = ({
	primary,
	updatePrimary,
	secondary,
	updateSecondary,
	link,
	updateLink,
	error,
	updateError
}: Props) => (
	<Grid container spacing={2}>
		<Color
			label={intl.tr('styleEditor.texts.primary')}
			hex={primary}
			onChange={updatePrimary}
			disableAlpha
		/>
		<Color
			label={intl.tr('styleEditor.texts.secondary')}
			hex={secondary}
			onChange={updateSecondary}
			disableAlpha
		/>
		<Color
			label={intl.tr('styleEditor.texts.link')}
			hex={link}
			onChange={updateLink}
			disableAlpha
		/>
		<Color
			label={intl.tr('styleEditor.texts.error')}
			hex={error}
			onChange={updateError}
			disableAlpha
		/>
	</Grid>
);

export default Inputs;
